import { type LiveProvider, type LiveEvent } from "@refinedev/core";
import { axiosInstance } from "@refinedev/simple-rest";
import * as Ably from "ably";
import config from "config/config";

const liveProvider = (client: Ably.Realtime): LiveProvider => {
  return {
    subscribe: ({ channel, types, params, callback }) => {
      const channelInstance = client.channels.get(channel);
      console.log(channel)

      const listener = (message: Ably.InboundMessage) => {
        if (types.includes("*") || types.includes(message.data.type)) {
          if (
            message.data.type !== "created" &&
            params?.ids !== undefined &&
            message.data?.payload?.ids !== undefined
          ) {
            if (
              params.ids
                .map(String)
                .filter((value) =>
                  message.data.payload.ids?.map(String).includes(value),
                ).length > 0
            ) {
              callback(message.data as LiveEvent);
            }
          } else {
            callback(message.data);
          }
        }
      };
      channelInstance.subscribe(listener);

      return { channelInstance, listener };
    },

    unsubscribe: (payload: {
      channelInstance: Ably.RealtimeChannel;
      listener: () => void;
    }) => {
      const { channelInstance, listener } = payload;
      channelInstance.unsubscribe(listener);
    },

    publish: (event: LiveEvent) => {
      const channelInstance = client.channels.get(event.channel);

      channelInstance.publish(event.type, event);
    },
  };
};

const authUrl = `${config.apiUrl}/ably/auth`;

var ablyClient: Ably.Realtime | null = null;

const authAbly = () => {
  ablyClient = new Ably.Realtime({
    authHeaders: axiosInstance.defaults.headers.common as any,
    authUrl: authUrl
  });
}

export { liveProvider, ablyClient, authAbly };

